module.exports = {
	"name": "Khóa học C++",
	"toggled": true,
	"level": 0,
	"path": "/",
	"children": [
		{
			"name": "Giới thiệu tổng quan khóa học",
			"children": [
				{
					"name": "0.0 Giới thiệu về series tutorial",
					"id": 29402,
					"path": "0/0-gioi-thieu-ve-series-tutorial"
				},
				{
					"name": "0.1 Giới thiệu về ngôn ngữ lập trình",
					"id": 29425,
					"path": "0/1-gioi-thieu-ve-ngon-ngu-lap-trinh"
				},
				{
					"name": "0.2 Giới thiệu về ngôn ngữ lập trình C++",
					"id": 29448,
					"path": "0/2-gioi-thieu-ve-ngon-ngu-lap-trinh-c"
				},
				{
					"name": "0.3 Các công đoạn phát triển của một chương trình C++",
					"id": 29449,
					"path": "0/3-cac-cong-doan-phat-trien-cua-mot-chuong-trinh-c"
				},
				{
					"name": "0.4 Giới thiệu môi trường phát triển ứng dụng C++",
					"id": 29503,
					"path": "0/4-gioi-thieu-moi-truong-phat-trien-ung-dung-c"
				},
				{
					"name": "0.5 Cài đặt IDE để lập trình C++",
					"children": [
						{
							"name": "Cài đặt Visual Studio 2015 để lập trình C++ trên Windows",
							"id": 24768,
							"path": "0/5-cai-dat-visual-studio-2015-de-lap-trinh-c-tren-windows"
						},
						{
							"name": "Cài đặt Xcode để lập trình C++ trên Mac OS X",
							"id": 24606,
							"path": "0/5-cai-dat-xcode-de-lap-trinh-c-tren-mac-os-x"
						},
						{
							"name": "Cài đặt Code::blocks để lập trình C++ trên Ubuntu/Linux",
							"id": 24563,
							"path": "0/5-cai-dat-code-blocks-de-lap-trinh-c-tren-ubuntu-linux"
						}
					]
				}
			],
			"level": 1
		},
		{
			"name": "C++ cơ bản",
			"children": [
				{
					"name": "1.0 Viết chương trình đầu tiên",
					"id": 29504,
					"path": "1/0-viet-chuong-trinh-dau-tien"
				},
				{
					"name": "1.1 Cấu trúc cơ bản của một chương trình C++",
					"id": 29527,
					"path": "1/1-cau-truc-co-ban-cua-mot-chuong-trinh-c"
				},
				{
					"name": "1.2 Lệnh, khối lệnh, từ khóa",
					"id": 29575,
					"path": "1/2-lenh-khoi-lenh-tu-khoa"
				},
				{
					"name": "1.3 Sử dụng các lệnh liên quan đến xuất dữ liệu",
					"id": 29796,
					"path": "1/3-su-dung-cac-lenh-lien-quan-den-xuat-du-lieu"
				},
				{
					"name": "1.4 Biến và các kiểu dữ liệu trong C++",
					"id": 29935,
					"path": "1/4-bien-va-cac-kieu-du-lieu-trong-c"
				},
				{
					"name": "1.5 Nhập và xuất dữ liệu",
					"id": 29936,
					"path": "1/5-nhap-va-xuat-du-lieu"
				},
				{
					"name": "1.6 Hằng số",
					"id": 29938,
					"path": "1/6-hang-so"
				},
				{
					"name": "1.7 Phạm vi của biến",
					"id": 29939,
					"path": "1/7-pham-vi-cua-bien"
				},
				{
					"name": "1.8 Các phép toán cơ bản",
					"id": 29944,
					"path": "1/8-cac-phep-toan-co-ban"
				},
				{
					"name": "1.9 Toán tử tăng giảm",
					"id": 29945,
					"path": "1/9-toan-tu-tang-giam"
				},
				{
					"name": "1.10 Độ ưu tiên của các toán tử",
					"id": 29574,
					"path": "1/10-do-uu-tien-cua-cac-toan-tu"
				}
			],
			"level": 1
		},
		{
			"name": "Cấu trúc rẽ nhánh",
			"children": [
				{
					"name": "2.0 Boolean",
					"id": 29992,
					"path": "2/0-boolean"
				},
				{
					"name": "2.1 Giới thiệu một số cấu trúc điều khiển",
					"id": 30007,
					"path": "2/1-gioi-thieu-mot-so-cau-truc-dieu-khien"
				},
				{
					"name": "2.2 if statements",
					"id": 30008,
					"path": "2/2-if-statements"
				},
				{
					"name": "2.3 switch case statements",
					"id": 30009,
					"path": "2/3-switch-case-statements"
				}
			],
			"level": 1
		},
		{
			"name": "Cấu trúc vòng lặp",
			"children": [
				{
					"name": "3.0 Vòng lặp while",
					"id": 30011,
					"path": "3/0-vong-lap-while"
				},
				{
					"name": "3.1 Vòng lặp do-while",
					"id": 30012,
					"path": "3/1-vong-lap-do-while"
				},
				{
					"name": "3.2 Vòng lặp for",
					"id": 30013,
					"path": "3/2-vong-lap-for"
				},
				{
					"name": "3.3 từ khóa break và continue",
					"id": 30014,
					"path": "3/3-tu-khoa-break-va-continue"
				}
			],
			"level": 1
		},
		{
			"name": "Nâng cao về biến, kiểu dữ liệu",
			"children": [
				{
					"name": "4.0 Sử dụng thư viện cstdint",
					"id": 30016,
					"path": "4/0-su-dung-thu-vien-cstdint"
				},
				{
					"name": "4.1 Kiểu kí tự",
					"id": 30018,
					"path": "4/1-kieu-ki-tu"
				},
				{
					"name": "4.2 Ép kiểu dữ liệu",
					"id": 30019,
					"path": "4/2-ep-kieu-du-lieu"
				},
				{
					"name": "4.3 auto và decltype",
					"id": 30020,
					"path": "4/3-auto-va-decltype"
				},
				{
					"name": "4.4 Địa chỉ của biến",
					"id": 30022,
					"path": "4/4-dia-chi-cua-bien"
				}
			],
			"level": 1
		},
		{
			"name": "Kiểu dữ liệu mảng",
			"children": [
				{
					"name": "5.0 Mảng một chiều",
					"id": 30080,
					"path": "5/0-mang-mot-chieu"
				},
				{
					"name": "5.1 Các thao tác cơ bản với mảng một chiều",
					"id": 30082,
					"path": "5/1-cac-thao-tac-co-ban-voi-mang-mot-chieu"
				},
				{
					"name": "5.2 Thư viện array trong STL",
					"id": 30083,
					"path": "5/2-thu-vien-array-trong-stl"
				},
				{
					"name": "5.3 Mảng hai chiều",
					"id": 30085,
					"path": "5/3-mang-hai-chieu"
				},
				{
					"name": "5.4 Các thao tác cơ bản với mảng hai chiều",
					"id": 30086,
					"path": "5/4-cac-thao-tac-co-ban-voi-mang-hai-chieu"
				}
			],
			"level": 1
		},
		{
			"name": "Kiểu chuỗi kí tự",
			"children": [
				{
					"name": "6.0 Mảng kí tự",
					"id": 30090,
					"path": "6/0-mang-ki-tu"
				},
				{
					"name": "6.1 Các thao tác cơ bản với mảng kí tự",
					"id": 30091,
					"path": "6/1-cac-thao-tac-co-ban-voi-mang-ki-tu"
				},
				{
					"name": "6.2 Thư viện string trong C++",
					"id": 30092,
					"path": "6/2-thu-vien-string-trong-c"
				}
			],
			"level": 1
		},
		{
			"name": "Cơ bản về Function",
			"children": [
				{
					"name": "7.0 Làm quen với khái niệm function",
					"id": 30132,
					"path": "7/0-lam-quen-voi-khai-niem-function"
				},
				{
					"name": "7.1 Thiết kế chương trình dựa trên khái niệm function",
					"id": 30133,
					"path": "7/1-thiet-ke-chuong-trinh-dua-tren-khai-niem-function"
				},
				{
					"name": "7.2 Truyền đối số cho hàm là giá trị hoặc tham chiếu",
					"id": 30319,
					"path": "7/2-truyen-doi-so-cho-ham-la-gia-tri-hoac-tham-chieu"
				},
				{
					"name": "7.3 Hàm trả về giá trị hoặc tham chiếu",
					"id": 30381,
					"path": "7/3-ham-tra-ve-gia-tri-hoac-tham-chieu"
				},
				{
					"name": "7.4 Tham số mặc định, tham số hằng",
					"id": 30382,
					"path": "7/4-tham-so-mac-dinh-tham-so-hang"
				},
				{
					"name": "7.5 Function overloading",
					"id": 30477,
					"path": "7/5-function-overloading"
				}
			],
			"level": 1
		},
		{
			"name": "Con trỏ",
			"children": [
				{
					"name": "8.0 Con trỏ",
					"id": 30541,
					"path": "8/0-con-tr"
				},
				{
					"name": "8.1 Toán tử tăng, giảm dùng cho con trỏ",
					"id": 30699,
					"path": "8/1-toan-tu-tang-giam-dung-cho-con-tr"
				},
				{
					"name": "8.2 Con trỏ và mảng một chiều",
					"id": 30788,
					"path": "8/2-con-tr-va-mang-mot-chieu"
				},
				{
					"name": "8.3 Con trỏ và mảng kí tự",
					"id": 30876,
					"path": "8/3-con-tr-va-mang-ki-tu"
				},
				{
					"name": "8.4 Cấp phát bộ nhớ động",
					"id": 31145,
					"path": "8/4-cap-phat-bo-nho-dong"
				},
				{
					"name": "8.5 Con trỏ và hằng",
					"id": 31355,
					"path": "8/5-con-tr-va-hang"
				},
				{
					"name": "8.6 Con trỏ void",
					"id": 31625,
					"path": "8/6-con-tr-void"
				},
				{
					"name": "8.7 Con trỏ trỏ đến con trỏ",
					"id": 32159,
					"path": "8/7-con-tr-tr-den-con-tr"
				},
				{
					"name": "8.8 Con trỏ và hàm",
					"id": 31810,
					"path": "8/8-con-tr-va-ham"
				},
				{
					"name": "8.9 Con trỏ hàm",
					"id": 31959,
					"path": "8/9-con-tr-ham"
				},
				{
					"name": "8.10 Phân loại các vùng nhớ (stack & heap ...)",
					"id": 32101,
					"path": "8/10-phan-loai-cac-vung-nho-stack-va-heap"
				},
				{
					"name": "8.11 Các vấn đề thường gặp khi sử dụng con trỏ",
					"id": 32133,
					"path": "8/11-cac-van-de-thuong-gap-khi-su-dung-con-tr"
				}
			],
			"level": 1
		},
		{
			"name": "Kiểu dữ liệu tự định nghĩa",
			"children": [
				{
					"name": "9.0 Kiểu liệt kê (enum)",
					"id": 32760,
					"path": "9/0-kieu-liet-ke-enum"
				},
				{
					"name": "9.1 Structs",
					"id": 33291,
					"path": "9/1-structs"
				},
				{
					"name": "9.2 Structs and pointer",
					"id": 33521,
					"path": "9/2-structs-and-pointer"
				}
			],
			"level": 1
		},
		{
			"name": "Nhập, xuất, streams (Input & Output)",
			"children": [
				{
					"name": "10.0 File và các thao tác cơ bản với file trong C",
					"id": 35276,
					"path": "10/0-file-va-cac-thao-tac-co-ban-voi-file-trong-c"
				},
				{
					"name": "10.1 Input/Output stream C++",
					"id": 35321,
					"path": "10/1-input-output-stream-c"
				},
				{
					"name": "10.2 Một số thao tác đọc dữ liệu từ File trong C++",
					"id": 35567,
					"path": "10/2-mot-so-thao-tac-doc-du-lieu-tu-file-trong-c"
				},
				{
					"name": "10.3 Một số thao tác ghi dữ liệu vào File trong C++",
					"id": 35622,
					"path": "10/3-mot-so-thao-tac-ghi-du-lieu-vao-file-trong-c"
				},
				{
					"name": "10.4 Streams for string C++",
					"id": 35649,
					"path": "10/4-streams-for-string-c"
				}
			],
			"level": 1
		},
		{
			"name": "Standard Template Library",
			"children": [
				{
					"name": "11.0 Giới thiệu về STL",
					"id": 34001,
					"path": "11/0-gioi-thieu-ve-stl"
				},
				{
					"name": "11.1 STL containers",
					"id": 34210,
					"path": "11/1-stl-containers"
				},
				{
					"name": "11.2 STL iterators",
					"id": 34567,
					"path": "11/2-stl-iterators"
				},
				{
					"name": "11.3 STL algorithms",
					"id": 34695,
					"path": "11/3-stl-algorithms"
				}
			],
			"level": 1
		},
		{
			"name": "Smart pointer",
			"children": [
				{
					"name": "12.0 unique_ptr"
				},
				{
					"name": "12.1 shared_ptr"
				}
			],
			"level": 1
		},
		{
			"name": "Quản lý mã nguồn",
			"children": [
				{
					"name": "13.0 Từ khóa static"
				},
				{
					"name": "13.1 Viết chương trình với nhiều file"
				},
				{
					"name": "13.2 Tạo và sử dụng thư viện liên kết tĩnh"
				},
				{
					"name": "13.3 Tạo và sử dụng thư viện liên kết động"
				}
			],
			"level": 1
		},
		{
			"name": "Một số feature trong C++11, C++14",
			"children": [
				{
					"name": "14.0 Function template"
				},
				{
					"name": "14.1 Lambda expression"
				},
				{
					"name": "14.2 Xử lý ngoại lệ"
				}
			],
			"level": 1
		}
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./content/toc.json
 ** module id = 427
 ** module chunks = 0
 **/